var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spnod-admin__form--container container pl-0 mx-0 d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button mb-2",
    attrs: {
      "size": "sm",
      "href": 'data:text/csv;charset=utf-8,' + encodeURIComponent(_vm.csv),
      "target": "_blank",
      "download": _vm.title
    }
  }, [_vm._v("\n      Download Template CSV\n    ")]), _vm._v(" "), _c('b-form-file', {
    ref: "fileInput",
    staticClass: "mb-3",
    attrs: {
      "size": "sm",
      "type": "file",
      "placeholder": "Choose a file or drop it here...",
      "drop-placeholder": "Drop file here...",
      "accept": ".csv",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        return _vm.handleUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "mb-4"
  }, [_vm._v("Minors will require parent consent!")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v("Uploaded Files:")]), _vm._v(" "), _c('ul', {
    staticClass: "pl-1"
  }, _vm._l((_vm.files), function(file, index) {
    return _c('li', {
      staticClass: "spnod-admin__form--list small mb-1 d-flex"
    }, [_c('p', {
      staticClass: "pr-2"
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('button', {
      staticClass: "text-danger font-weidth-bold",
      on: {
        "click": function($event) {
          return _vm.handleRemove(index)
        }
      }
    }, [_vm._v("x")])])
  }), 0)]), _vm._v(" "), _c('b-form-group', [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "size": "sm",
      "disabled": _vm.disableReview
    },
    on: {
      "click": _vm.handleReview
    }
  }, [(!_vm.isProcessing) ? _c('p', [_vm._v("Review Upload")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/group/users"
    }
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "size": "sm"
    }
  }, [_vm._v("Skip")])], 1)], 1)], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-2"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v("File must be in CSV format")]), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("Required fields:")]), _vm._v(" "), _c('ul', {
    staticClass: "pl-4"
  }, [_c('li', {
    staticClass: "small mb-1"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('li', {
    staticClass: "small mb-1"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('li', {
    staticClass: "small mb-1"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('li', {
    staticClass: "small mb-1"
  }, [_vm._v("Email")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-782364ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Forms/BulkUploadForm.vue
// module id = HnEP
// module chunks = 2